import Wrapper from './components/Wrapper';
import Title from './components/Title';
import Content from './components/Content';

const SignUpLayout = {
  Wrapper,
  Title,
  Content,
};

export default SignUpLayout;
